import { render } from "./review_promotion.vue?vue&type=template&id=4043350a"
import script from "./review_promotion.vue?vue&type=script&lang=js"
export * from "./review_promotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__